import { memo } from 'react';

import ParallelAttribute from '../../../parallel-attribute/ParallelAttribute.js';

import {
    HeaderDetailsContainer,
    CardNumber,
    TagsContainer,
    Name,
} from './HeaderDetails.styles.js';

function normalizeAttributes(attrs) {
    if (!attrs?.length) return [];
    return attrs.map((a) =>
        typeof a === 'string' ? { text: a, color: '#FFFFFF' } : { text: a.text ?? a.name, color: a.color ?? '#FFFFFF' }
    );
}

function HeaderDetailsInner({ card }) {
    const players = card?.name ?? card?.players ?? [];
    const playerNames = Array.isArray(players) ? players.join(', ') : String(players ?? '');
    const cardAttributes = card?.cardAttributes ?? card?.attributes ?? [];
    const attributes = normalizeAttributes(cardAttributes);
    const team = card?.team;

    return (
        <HeaderDetailsContainer>
            <CardNumber>#{card?.cardNumber ?? ''}</CardNumber>
            <Name>{playerNames}</Name>
            <TagsContainer>
                {Array.isArray(team) && team.length > 0
                    ? team.map((t, i) => (
                        <ParallelAttribute key={`team-${i}`} color="#1E88E5" text={t} isAlwaysExpanded />
                    ))
                    : team && typeof team === 'string'
                        ? <ParallelAttribute color="#1E88E5" text={team} isAlwaysExpanded />
                        : null}
                {attributes.map((attr, i) => (
                    <ParallelAttribute
                        key={`attr-${i}`}
                        color={attr.color}
                        text={attr.text}
                        isAlwaysExpanded
                    />
                ))}
            </TagsContainer>
        </HeaderDetailsContainer>
    );
}

export default memo(HeaderDetailsInner);
